module.exports = __webpack_public_path__ + "static/media/logo.17963089.png";